import { gql } from "@apollo/client";

const TRANSLATION_MUTATION = gql`
  mutation translation($projectId: String!, $source: String, $target: String, $text: String!) {
    translation(
      input: {projectId: $projectId, source: $source, target: $target, text: $text}
    ) {
      papago
      __typename
    }
  }
`;

const WRITE_MUTATION = gql`
  mutation Write($topic: String!) {
    write (
      topic: $topic
    ) {
       topic
       content
    }
  }
`;

const SPELL_CHECK_MUTATION = gql`
  mutation SpellCheck($text: String!) {
    spellCheck(
      text: $text
    ) {
       originalText
       correctedText
       suggestions
    }
  }
`;

export {
  TRANSLATION_MUTATION,
  WRITE_MUTATION,
  SPELL_CHECK_MUTATION
}; 